export const KRATOS_SUB_PREFIX = 'kratos|';
/**
 * This prefix identifies users that are authenticated with a business employee UUID.
 * Can either come from MitID or SEB.
 */
export const DKAUTH_SUB_PREFIX = 'dkid|';
export const ONELOGIN_SUB_PREFIX = '1login|';
export const EPIC_SUB_PREFIX = 'epic|';

export const LOGIN_SUB_PREFIXES = [
  KRATOS_SUB_PREFIX,
  DKAUTH_SUB_PREFIX,
  ONELOGIN_SUB_PREFIX,
  EPIC_SUB_PREFIX,
] as const;

export type LoginSubPrefix = (typeof LOGIN_SUB_PREFIXES)[number];

/**
 * A Learn account signs in through Auth0, so its sub is still its Auth0 sub.
 * Desktop accounts split from a Learn account keep `auth0Sub` but not as sub.
 * The user search's `excludeLearnUsers` filter is the SQL form; change both together.
 */
export const isLearnUser = (user: {
  sub?: string | null;
  auth0Sub?: string | null;
}) => !!user.auth0Sub && user.sub === user.auth0Sub;
